__turbopack_context__.v({
  "animated": "nav-menu-module__LGAYPq__animated",
  "disabled": "nav-menu-module__LGAYPq__disabled",
  "expanded": "nav-menu-module__LGAYPq__expanded",
  "hamburger": "nav-menu-module__LGAYPq__hamburger",
  "item": "nav-menu-module__LGAYPq__item",
  "label": "nav-menu-module__LGAYPq__label",
  "open": "nav-menu-module__LGAYPq__open",
  "overlay": "nav-menu-module__LGAYPq__overlay",
  "overlayIn": "nav-menu-module__LGAYPq__overlayIn",
  "panel": "nav-menu-module__LGAYPq__panel",
  "selectedItem": "nav-menu-module__LGAYPq__selectedItem",
});
